// ============================================
// COLLECTION PAGE JS
// ============================================

class FacetFilters extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.form?.addEventListener('change', debounce(this.onFilterChange.bind(this), 300));
  }
  
  async onFilterChange() {
    const formData = new FormData(this.form);
    const params = new URLSearchParams(formData);
    const url = `${window.location.pathname}?${params}`;
    
    history.pushState({}, '', url);
    
    const grid = document.querySelector('[data-product-grid]');
    if (grid) grid.style.opacity = '0.5';
    
    try {
      const res = await fetch(`${url}&section_id=main-collection`);
      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newGrid = doc.querySelector('[data-product-grid]');
      const newCount = doc.querySelector('[data-product-count]');
      
      if (newGrid && grid) {
        grid.innerHTML = newGrid.innerHTML;
        grid.style.opacity = '1';
      }
      if (newCount) {
        document.querySelector('[data-product-count]').innerHTML = newCount.innerHTML;
      }
    } catch (err) {
      console.error('Filter failed:', err);
      grid.style.opacity = '1';
    }
  }
}
customElements.define('facet-filters', FacetFilters);

document.querySelectorAll('[data-sort-by]').forEach(select => {
  select.addEventListener('change', (e) => {
    const url = new URL(window.location);
    url.searchParams.set('sort_by', e.target.value);
    window.location = url;
  });
});

function debounce(fn, wait) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), wait);
  };
}

console.log('Collection page JS loaded');
